export default "__VITE_ASSET__BsoDZ6J8__"